import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../sections/Hero";
import Features from "../sections/Features";
import Activities from "../sections/Activities";
import ParentSpeak from "../sections/ParentSpeak";
import Gallery from "../sections/Gallery";
import Faq from "../sections/Faq";
import Admission from "../sections/Admission";
import { HOME_SECTIONS } from "../routes";

/** The single-page home. URLs like /Gallery or /Activities scroll to that section. */
export default function Home() {
  const { pathname, key } = useLocation();

  useEffect(() => {
    const sectionId = HOME_SECTIONS[pathname.toLowerCase()];
    const target = sectionId && document.getElementById(sectionId);

    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    // `key` changes on every navigation, so clicking the same link again re-scrolls.
  }, [pathname, key]);

  return (
    <>
      <Hero />
      <Features />
      <Activities />
      <ParentSpeak />
      <Gallery />
      <Faq />
      <Admission />
    </>
  );
}
